import PropTypes from 'prop-types';
import React from 'react'


const SEO = ( { title } ) => {
    return (
        <>
            <meta charSet="utf-8" />
            <title>{ title } || FETC - Foreign English Test Capital</title>
            <meta name="robots" content="noindex, follow" /> 
            {/* /// TODO: make description dynamic */}
            <meta name="description" content="Work, Study & Settle Abroad.Your one stop solution in navigating the path to global success." />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        </>
    )
}
SEO.propTypes = {
    title: PropTypes.string
};

export default SEO;